import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SaveUser from '../../../UserSave/index';

export default () => (
  <Switch>
    <Route exact path="/saveUser" component={SaveUser} />
  </Switch>
);
